import './style.css';
import htmlFrag from './footer.frag.html';

export async function initFooter () {
  const $dom = document.querySelector('#footer');
  $dom.outerHTML = htmlFrag;
}
